export default __webpack_public_path__ + "static/media/Metabell总部_white.3373849d.jpg";